import { render, staticRenderFns } from "./CtaCalendar.vue?vue&type=template&id=b228812c&"
import script from "./CtaCalendar.vue?vue&type=script&lang=js&"
export * from "./CtaCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CtaCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports